import './styles.css';
import { PeaceLabsGame } from './gameplay.js';

const game = new PeaceLabsGame();
game.initialize().catch(error => {
  document.getElementById('loadingText').textContent = error.message;
  document.getElementById('loading').classList.add('failed');
});

window.PeaceLabs = game;
